import { useLegendLayer } from '../hooks'


const LegendLayer = ({ mapId, url, sublayers }) => {
  useLegendLayer(mapId, url, sublayers)
  return null
}


export default LegendLayer